import React from 'react';

const Divider = () => {
  return <hr style={{ borderTop: '1px solid #eee', margin: '100px 100px' }} />;
};

export default Divider;
